import { FC } from 'react';
import { Avatar, Collapse } from 'antd';
import { useMeMember } from '@/core/gql/helpers/hooks';
import { useHasPermissions, useClientSettings } from '@/shared/access';
import { useGettext } from '@cranium/i18n';
import styled from 'styled-components';
import { Link } from '@/shared/navigation';
import { openContractorsStatusModal } from '@components/ContractorStatusView';
import { closeMenuDrawer } from './utils';

export const MobileProfile: FC = props => {
  const member = useMeMember();
  const { gettext } = useGettext();
  const canShowProfile = useHasPermissions('permissions.profile.show');
  const canShowStatusPage = useHasPermissions('permissions.profile.account_status.show');
  const partnerStatusIsVisible = useClientSettings()?.partner_status?.visible;
  const { managerName, avatar } = member ?? {};
  const nameInitial = managerName?.split('')[0]?.toUpperCase() ?? 'N/A';

  const menuItems = [
    {
      element: (
        <Link to="/profile">
          <Root nested onClick={() => closeMenuDrawer()}>
            {gettext('Settings')}
          </Root>
        </Link>
      ),
      key: 'profile',
      permission: canShowProfile
    },
    {
      permission: canShowStatusPage && partnerStatusIsVisible,
      element: (
        <Root
          nested
          onClick={() => {
            openContractorsStatusModal();
            closeMenuDrawer();
          }}
        >
          {gettext('Status page')}
        </Root>
      ),
      key: 'status'
    }
  ]
    .filter(item => item?.permission)
    .map(item => item.element);

  return (
    <>
      <Collapse.Panel
        {...props}
        key="profile"
        header={
          <Root>
            <Avatar src={avatar} size={22}>
              {nameInitial}
            </Avatar>
            {gettext('Profile')}
          </Root>
        }
      >
        {menuItems}
      </Collapse.Panel>
    </>
  );
};

const Root = styled.div<{ nested?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font: var(--font-normal-18) !important;
  color: var(--gray-7) !important;
  height: 48px;
  padding-left: ${props => (props.nested ? '40px' : '8px')};
  border-radius: 4px;

  &:hover {
    background: var(--green-2) !important;
    color: var(--gray-9) !important;
    border-radius: 4px !important;
  }
  .ant-icon {
    font-size: 22px !important;
    color: var(--gray-7) !important;
    margin-left: 8px !important;
  }
`;
